import React, { Fragment } from "react";
import { get } from "lodash";
import T from "prop-types";
import {
  DetailTable,
  CheckForDetail
} from "MODULES/shared/components/DetailTable";
import Section from "MODULES/shared/components/Section";
import pojo from "LIB/pojos";
import {
  CREDIT_DENIED,
  CREDIT_ISSUED,
  CREDIT_REQUESTED,
  CUSTOMER_RMA_CREDIT_AMOUNT,
  CUSTOMER_RMA_TYPE,
  PARTIAL_CREDIT_AMT,
  PARTIAL_CREDIT_REQUESTED,
  PARTIAL_CREDIT_STATUS
} from "MODULES/RMAsAndWarranties/constants";
import { properCase } from "LIB/formatters/text";
import Form from "./Form";
import AuditedNoteTooltip from "../../../../../shared/components/NoteTooltip/AuditedNoteTooltip";

function FullCreditSection({ rma }) {
  if (!rma.credit_requested) return null;

  return (
    <React.Fragment>
      <CheckForDetail
        label="Full Credit Requested?"
        value={rma.credit_requested}
      />
    </React.Fragment>
  );
}

export default function CustomerRmaCreditSection({ rma }) {
  if (get(rma, "inventory.managed_repair_in_progress")) return null;
  if (rma.type !== CUSTOMER_RMA_TYPE) return null;

  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <Section
        title="Credit"
        editable={
          !(
            rma.type === CUSTOMER_RMA_TYPE &&
            rma.sales_item.received &&
            rma.sales_item.exchange_sale
          )
        }
        modal={{
          title: "Edit Credit Details",
          content: close => (
            <Form
              initialValues={pojo(rma).pick(
                CREDIT_REQUESTED,
                CREDIT_ISSUED,
                CREDIT_DENIED,
                CUSTOMER_RMA_CREDIT_AMOUNT,
                PARTIAL_CREDIT_REQUESTED,
                PARTIAL_CREDIT_STATUS,
                PARTIAL_CREDIT_AMT
              )}
              rma={rma}
              close={close}
            />
          )
        }}
      >
        <DetailTable>
          <FullCreditSection rma={rma} />
          {rma.partial_credit_requested && (
            <React.Fragment>
              <CheckForDetail
                label={properCase(PARTIAL_CREDIT_REQUESTED)}
                value={rma.partial_credit_requested}
                renderIfPresent
              />
            </React.Fragment>
          )}
          <CheckForDetail
            label={
              rma.partial_credit_requested
                ? "Partial Credit Issued?"
                : "Full Credit Issued?"
            }
            value={rma.credit_issued}
            text={
              <Fragment>
                Yes{" "}
                {rma.credit_issued_audit && (
                  <AuditedNoteTooltip obj={rma} field="credit_issued" />
                )}
              </Fragment>
            }
          />
          <CheckForDetail
            label={
              rma.partial_credit_requested
                ? "Partial Credit Denied?"
                : "Full Credit Denied?"
            }
            value={rma.credit_denied}
          />
        </DetailTable>
      </Section>
    </React.Fragment>
  );
}

CustomerRmaCreditSection.propTypes = {
  rma: T.shape({
    credit_requested: T.bool,
    issue_credit: T.bool,
    credit_issued: T.bool,
    partial_credit_status: T.string,
    partial_credit_amt: T.string,
    sales_item: T.shape({
      received: T.bool,
      exchange_sale: T.bool
    })
  })
};



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/CustomerRmaCreditSection/CustomerRmaCreditSection.jsx